import { createStore } from "redux";
import rootReducer from "app/redux/rootReducer";

function configureStore(state = { counter: 10 }) {
  return createStore(rootReducer,state);
}
export default configureStore;